import get from 'lodash/get';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import {formDataManager} from 'hoc/formDataManager';
import AwardSpinsModal from './AwardSpinsModal';
import config from './awardSpinsFormConfig';
import {submitAwardSpinsAction, endAwardSpinsAction} from '../../../actions';

const mapStateToProps = state => {
  const {awardingSpins, awardSpinsSubmitted, currentUserId, currentUser} = state.userManagement;
  return {
    userId: currentUserId,
    email: get(currentUser, 'email', null),
    modalOpen: awardingSpins,
    awarding: awardSpinsSubmitted
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  awardSpins: submitAwardSpinsAction,
  handleClose: endAwardSpinsAction
}, dispatch);

const AwardSpinsModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSaveData: props => data => props.awardSpins(Number(props.userId), Number(data.amount))
  }),
  formDataManager({amount: ''}, config)
)(AwardSpinsModal);

export default AwardSpinsModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/AwardSpinsModal/AwardSpinsModalContainer.js